import Mapper from 'ln/model/Mapper';

import {register as registerGlossaryModel} from './GlossaryModel';
import {register as registerTermModel} from './TermModel';

export default function registerModels(mapper: Mapper) {
    registerGlossaryModel(mapper);
    registerTermModel(mapper);
}
